// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1Hc5o","topBottomGutter":"Layout_topBottomGutter__3jNS3"};